// Module
var code = `<div class="flag-label">{{\$ctrl.text}}</div> `;
// Exports
export default code;